/**
 * Converts a date string to a localized date string.
 * @param date - The date string to convert.
 * @param options - The options to pass to the toLocaleDateString method.
 *                 See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
 *                      https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#syntax
 * @param lang - The language to pass to the toLocaleDateString method.
 * @returns A localized date string.
 */
export const dateString = (
	date,
	options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	},
	lang = 'en-US'
) => {
	return new Date(date).toLocaleDateString(lang, options);
};

export const schemaString = (
	date,
	options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	},
	lang = 'en-US'
) => {
	options.timeZone = 'America/New_York';
	return new Date(date).toLocaleDateString(lang, options);
};

export const formatDateString = (dateString) => {
	// TODO: Find a better way to handle timezones...
	// Right now there's a hydration error when using the toLocaleDateString method
	// Since the client running this assumes your local timezone, but the server is running in it's own.
	// This is a temporary fix to get the date to display correctly.
	// We should find a better way to handle this.
	// I'm betting that Builder.io will store the date timestamp based on your local timezone too
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', {
		timeZone: 'America/New_York',
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	});
};

// Day of month
export const getDay = (date) => {
	return new Date(date).toLocaleDateString('en-US', {
		timeZone: 'America/New_York',
		day: 'numeric',
	});
};
// Month
export const getMonth = (date) => {
	return new Date(date).toLocaleDateString('en-US', {
		timeZone: 'America/New_York',
		month: 'long',
	});
};
// Year
export const getYear = (date) => {
	return new Date(date).toLocaleDateString('en-US', {
		timeZone: 'America/New_York',
		year: 'numeric',
	});
};
